<template>
<span class="label" :class="classes">
  {{ stateForHuman }}
</span>
</template>
<script>
export default {
  props: {
    state: {type: Boolean, required: true}
  },
  computed: {
    classes () {
      return {
        'label-danger': !this.state,
        'label-success': this.state
      }
    },
    stateForHuman () {
      switch (this.state) {
        case true:
          return 'TAK'
        default:
          return 'NIE'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BooleanState.vue?32efd024